import type { ExpiryBannerModel } from '@shared/trial-display'

export default function TrialBanner({ banner }: { banner: ExpiryBannerModel | null }) {
  if (!banner) return null

  return (
    <div className="w-full bg-amber-500 text-white text-xs font-semibold px-4 py-1.5 text-center">
      {banner.prefix} {banner.timeLabel} — contact {banner.contactName}
    </div>
  )
}